module.exports = __webpack_public_path__ + "static/media/clinic.5d091f33.png";